/// <amd-module name="TFS/Admin/Common/Controls/DeleteDialog/DeleteDialog" />
import * as React from "react";

import { Dialog } from "VSSUI/Dialog";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { VssComponent } from "VSS/Platform/Layout";
import * as Resources from "TFS/Admin/Common/Controls/Resources";
import { IButtonProps } from "VSSUI/Button";
import { IDeleteDialogProps } from "TFS/Admin/Common/Controls/DeleteDialog/DeleteDialog.Props";

export class DeleteDialog extends React.Component<IDeleteDialogProps> {
    constructor(props: IDeleteDialogProps) {
        super(props);
    }

    public render(): JSX.Element {
        return (
            <Dialog titleProps={{ text: this.props.dialogTitle }} onDismiss={this.props.onCancel} footerButtonProps={this._getFooterButtonProps()}>
                <div className="flex-column rhythm-vertical-8">
                    <div>
                        <FormatComponent className="delete-dialog-wrap" format={this.props.confirmationMessage}>
                            <span className="fontWeightSemiBold">{this.props.itemName}</span>
                            <span>{this.props.groupOrUserName}</span>
                        </FormatComponent>
                    </div>
                    <div>{this.props.warningMessage}</div>
                </div>
            </Dialog>
        );
    }

    private _getFooterButtonProps(): IButtonProps[] {
        var buttonText: string = this.props.deleteButtonLabel ? this.props.deleteButtonLabel : Resources.DeleteButton;

        return [
            {
                text: Resources.CancelButton,
                onClick: this.props.onCancel
            },
            {
                text: buttonText,
                danger: true,
                onClick: () => this.props.onDeleteItemConfirm(this.props.itemToDelete)
            }
        ];
    }
}

VssComponent.register("ms.vss-admin-web.delete-dialog", DeleteDialog);
